module.exports = __webpack_public_path__ + "assets/img/list_empty.84ec742a.png";